import { render } from "./ActionEdit.vue?vue&type=template&id=3b7641d2&scoped=true&ts=true"
import script from "./ActionEdit.vue?vue&type=script&lang=ts"
export * from "./ActionEdit.vue?vue&type=script&lang=ts"

import "./ActionEdit.vue?vue&type=style&index=0&id=3b7641d2&lang=scss"
import "./ActionEdit.vue?vue&type=style&index=1&id=3b7641d2&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b7641d2"]])

export default __exports__